import Vue from 'vue'


export const setScreenRatio = (val) => {
	localStorage.setItem('ScreenRatio', val)
}

export const getScreenRatio = () => {
	return localStorage.getItem("ScreenRatio") ?
		localStorage.getItem("ScreenRatio") : 'normal'
}

export const setUserId = (val) => {
	localStorage.setItem(Vue.prototype.$projectPrefix + 'UserId', val)
}

export const getUserId = () => {
	return localStorage.getItem(Vue.prototype.$projectPrefix + "UserId")
}


export const setAuthorityToken = (val) => {
	localStorage.setItem(Vue.prototype.$projectPrefix + 'AuthorityToken', val)
}

export const getAuthorityToken = () => {
	return localStorage.getItem(Vue.prototype.$projectPrefix + "AuthorityToken")
}

export const removeAuthorityToken = () => {
	return localStorage.removeItem(Vue.prototype.$projectPrefix + "AuthorityToken")
}


// WEBPACK FOOTER //
// ./src/utils/storageUtil.js